/**
 * It's suggested to configure the RESTful endpoints in this file
 * so that there is only one source of truth, future update of endpoints
 * could be done from here without refactoring on multiple places throughout the app
 */

const BACKEND_HOST = `https://api.fastship.co/api`;
//const BACKEND_HOST = `http://api.fastship.co/api`;
//const TOKEN = `eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImQ3YTRjNGQ3YzVmMzU2NzJjYzNjZWZjMGNhYjA1ZmY0OTZhM2E2Y2EzYWExM2I0NjM5YzZkYmIzZDIyOWJmZmI3ODJlMGU3NGY2YWU4OWU0In0.eyJhdWQiOiIxIiwianRpIjoiZDdhNGM0ZDdjNWYzNTY3MmNjM2NlZmMwY2FiMDVmZjQ5NmEzYTZjYTNhYTEzYjQ2MzljNmRiYjNkMjI5YmZmYjc4MmUwZTc0ZjZhZTg5ZTQiLCJpYXQiOjE2MDYzMTk0MzUsIm5iZiI6MTYwNjMxOTQzNSwiZXhwIjoxNjM3ODU1NDM1LCJzdWIiOiIzIiwic2NvcGVzIjpbXX0.zYX4Cm4tNzkP6aUZchblWEF52n6GXYO5peh9BsXO6Y5BETHOuhJF9p_Yg1jLrp2-ceHaNQ7q6vn0Re_FpKcjySB9wTMp3-7evX-_RseaA2d-2oLfwjXeU0SkVD_pRwaMgRhxRDUzMoymrIZMDAZuXgr4EwdvOyUgdqbz9hxwF-T0iKhwL-4FkCijjV82wRX7h4nM7G1qV78KUXsYNX3cJiVBgLBEtH2g9xPGljWMJIkcltlFgdsGBVkI0litBFpHFykA_9_TQXqtzgzBpfjMhfgFJ-VtmlfiQJNClfmyXKU8LF7QxObv8ejVRtSJDC7ugsTQuUO6ikEE5pbTU_bvrsYE0Krt2SqyGfN1dUsDdtm_CwzjbBr7412XrBdOfF01Os0gY6nK9OxcpZ9uUCUkf3GchlfBwxgBeJESMcEYVDZuhc92CgexmjOOzIaRz3Ck7J4_w5LIV3I1RgoGAaavLJKBT6xOzIQe-PpHrMN3kyMMewuLbYWA4cRa8ItKvpTGV30-dO545jpKNaibfkXJl830096BReyS8_iDuhw8Y9YzUygEbBrh1Dcl2RLUCa-BHgGKk34MCoog7xBubCojgwYhwfwTvJwFy2xmdX4s6Oetex3OslAp90vj5gjcFl2c_iA0Dp3p2LLsIZbH5Uiy9SY82tsdAi6AS3-OdJGZLZI`;

//new 21/06/22
const TOKEN =
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImU1YWI3ZmVkYzkzZTZjNzY2YzFiMjQ1NTc3NzkyZTgxYjJjZmE3M2EzMjI2ZGI1MjZhZDVjYjE3Yjg0ZTEzYjU1MjdhODVhNTk2YTM0ZjcxIn0.eyJhdWQiOiIxIiwianRpIjoiZTVhYjdmZWRjOTNlNmM3NjZjMWIyNDU1Nzc3OTJlODFiMmNmYTczYTMyMjZkYjUyNmFkNWNiMTdiODRlMTNiNTUyN2E4NWE1OTZhMzRmNzEiLCJpYXQiOjE3NzIwMjA0NzAsIm5iZiI6MTc3MjAyMDQ3MCwiZXhwIjoxODAzNTU2NDcwLCJzdWIiOiIxNCIsInNjb3BlcyI6W119.mWOrgmIMTRiF4EaAMf6cP3X8_5eY-GbRjsjbsUKQKSfnn_a2aqq2hO97EATkLwc-V8hzBW243PuCXgsIK7qEiJiT_vDQLNJOkHjOL5YzwxqdPS5zFX6ooxIDiPS0ku1AeBe_cXv5Qm2Zk9IYw5OBvxSuK4D0YG2x8XJt76UnprGGpa5kRGZ3PiuUYY0fTisn_OVfe_-mMo06euYQxTtabPGRagg1rBL6-msRGn7p4eoTuaB__O3v8HvftQhcmbzVZ5bL_NsSyX-w7HxqtFq2gHfBKL8gVJPdMcdr3_4pKoeL0GNScYbeCFB8MvP3QAZmsjNbtyH4qSuR5Rfz6c9cEQZlKG6XMHf3FSUthBzwpAEzuheW_KUcgjKjhxW73LTzQiqNLsFMVHAWHigHSJBd3OCgmx3y2VWSmu-8nEKNL8C9iY5wydnA2ePNEKmVnjWipaE2Ztomi_nchc1U2IMR8MnLT5JXWC-whi_DMaWddOdMGmH9CpCB4hfiH_pnVL24utnDMPRwkFCpXpy2B33mLZektRUlOMRJ-8Z3XVG1w33jf-SJ1OvRswIIr1HvHKF2AbHKI7drYgt1st7O82yfslDSsZBXeO9npsB2WJlDhJTGeWHa5EEUGn2lt6lUzCmYKssaGUaAwurn4quTfahHom_BYWMN1er8dLknL1W7iH4';

const TOKEN_NEW = `eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImU1YWI3ZmVkYzkzZTZjNzY2YzFiMjQ1NTc3NzkyZTgxYjJjZmE3M2EzMjI2ZGI1MjZhZDVjYjE3Yjg0ZTEzYjU1MjdhODVhNTk2YTM0ZjcxIn0.eyJhdWQiOiIxIiwianRpIjoiZTVhYjdmZWRjOTNlNmM3NjZjMWIyNDU1Nzc3OTJlODFiMmNmYTczYTMyMjZkYjUyNmFkNWNiMTdiODRlMTNiNTUyN2E4NWE1OTZhMzRmNzEiLCJpYXQiOjE3NzIwMjA0NzAsIm5iZiI6MTc3MjAyMDQ3MCwiZXhwIjoxODAzNTU2NDcwLCJzdWIiOiIxNCIsInNjb3BlcyI6W119.mWOrgmIMTRiF4EaAMf6cP3X8_5eY-GbRjsjbsUKQKSfnn_a2aqq2hO97EATkLwc-V8hzBW243PuCXgsIK7qEiJiT_vDQLNJOkHjOL5YzwxqdPS5zFX6ooxIDiPS0ku1AeBe_cXv5Qm2Zk9IYw5OBvxSuK4D0YG2x8XJt76UnprGGpa5kRGZ3PiuUYY0fTisn_OVfe_-mMo06euYQxTtabPGRagg1rBL6-msRGn7p4eoTuaB__O3v8HvftQhcmbzVZ5bL_NsSyX-w7HxqtFq2gHfBKL8gVJPdMcdr3_4pKoeL0GNScYbeCFB8MvP3QAZmsjNbtyH4qSuR5Rfz6c9cEQZlKG6XMHf3FSUthBzwpAEzuheW_KUcgjKjhxW73LTzQiqNLsFMVHAWHigHSJBd3OCgmx3y2VWSmu-8nEKNL8C9iY5wydnA2ePNEKmVnjWipaE2Ztomi_nchc1U2IMR8MnLT5JXWC-whi_DMaWddOdMGmH9CpCB4hfiH_pnVL24utnDMPRwkFCpXpy2B33mLZektRUlOMRJ-8Z3XVG1w33jf-SJ1OvRswIIr1HvHKF2AbHKI7drYgt1st7O82yfslDSsZBXeO9npsB2WJlDhJTGeWHa5EEUGn2lt6lUzCmYKssaGUaAwurn4quTfahHom_BYWMN1er8dLknL1W7iH4`;

const API = {
  auth: {
    index: '/auth',
    login: '/login',
    signUp: '/signup',
    refresh: '/get-access-token',
  },
  customer: {
    index: '/customer',
    login: '/login',
    get: '/',
  },
  credit: {
    index: '/credit_balance',
    get: '/balance',
    history: '/statement',
  },
  address: {
    index: '/address',
    countries: '/country',
    query: '_query/',
  },
  shipment: {
    index: '/shipment',
    rate: '/rates',
    rate_multibox: '/rates_multi',
    create: '/create_franchise',
    create_new: '/create',
    update: '/update_franchise',
    receive: '/receive_franchise',
    search: '/fullsearch',
    cancel: '/cancel',
    processlog: '/processlog',
  },
  pickup: {
    index: '/pickup',
    rate: '/rates',
    create: '/create_franchise',
    create_new: '/pickup/create',
    update: '/update',
    search: '/search',
  },
  product: {
    index: '/product',
    list: '/list',
    detail: '/product-detail',
    post: '/product-post',
  },
  facebook: {
    index: '/facebook',
    groupPost: '/group-post',
    connect: '/connect-post',
  },
  notify: {
    index: '/notify',
    newshipment: '/newshipment',
    emailOTP: '/kycotp',
  },
  bill: {
    index: '/bill',
    search: '/search',
    confirm: '/confirm',
  },
};

export { BACKEND_HOST, TOKEN, API, TOKEN_NEW };
